export const ADD_TREE_MAP = 99991;
export const ON_DELETE = 99992;
export const CLOSE = 9999;
export const STORE = "store_modal";
